import React from "react";

interface SocialIconProps {
  href: string;
  label?: string;
  imgSrc?: string;
  imgAlt?: string;
  imgClassName?: string;
  imgWidth?: number;
  imgHeight?: number;
}

const SocialIcon: React.FC<SocialIconProps> = (props) => {
  return (
    <a href={props.href}>
      {props?.label && props.label}
      {props?.imgSrc && (
        <img
          src={props.imgSrc}
          width={props?.imgWidth || 18}
          height={props?.imgHeight || 20}
          alt={props?.imgAlt || ""}
          className={props?.imgClassName || "social-icon"}
        />
      )}
    </a>
  );
};

export default SocialIcon;
